import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoPipe } from '@ngneat/transloco';

/**
 * Anillo de "perfil completo" alrededor de un avatar. Envuelve al avatar
 * (`<app-anillo-perfil [porcentaje]="p"><img …></app-anillo-perfil>`) y dibuja
 * el anillo por encima, con posición absoluta: no cambia el tamaño del avatar
 * ni mueve nada en pantallas chicas. Al 100 % (o sin dato) no se pinta.
 */
@Component({
    selector: 'app-anillo-perfil',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoPipe],
    template: `
        <ng-content></ng-content>
        @if (visible) {
            <svg
                class="anillo-perfil-svg"
                viewBox="0 0 100 100"
                role="img"
                [attr.aria-label]="'perfilCompleto.anillo' | transloco: { porcentaje: porcentaje }"
            >
                <title>{{ 'perfilCompleto.anillo' | transloco: { porcentaje: porcentaje } }}</title>
                <circle class="anillo-perfil-fondo" cx="50" cy="50" r="48" pathLength="100"></circle>
                <circle
                    class="anillo-perfil-avance"
                    cx="50"
                    cy="50"
                    r="48"
                    pathLength="100"
                    [attr.stroke-dasharray]="porcentaje + ' 100'"
                ></circle>
            </svg>
        }
    `,
    styles: [
        `
            :host {
                position: relative;
                display: inline-flex;
                flex-shrink: 0;
                border-radius: 9999px;
            }
            .anillo-perfil-svg {
                position: absolute;
                inset: var(--anillo-separacion, -4px);
                width: calc(100% - 2 * var(--anillo-separacion, -4px));
                height: calc(100% - 2 * var(--anillo-separacion, -4px));
                transform: rotate(-90deg);
                pointer-events: none;
                overflow: visible;
            }
            .anillo-perfil-svg circle {
                fill: none;
                stroke-width: var(--anillo-grosor, 3px);
                vector-effect: non-scaling-stroke;
            }
            .anillo-perfil-fondo {
                stroke: rgba(148, 163, 184, 0.35);
            }
            .anillo-perfil-avance {
                stroke: var(--fuse-primary, #4f46e5);
                stroke-linecap: round;
                transition: stroke-dasharray 0.4s ease;
            }
        `,
    ],
})
export class AnilloPerfilComponent {
    /** 0–100. `null` = sin datos todavía: no se pinta. */
    @Input() porcentaje: number | null = null;

    get visible(): boolean {
        return this.porcentaje !== null && this.porcentaje !== undefined && this.porcentaje < 100;
    }
}
